// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__m1hX3","loaderOuter":"PageOverlayLoader_loaderOuter__31KFu"};